import { render, staticRenderFns } from "./ValueModules.vue?vue&type=template&id=1b44148f&scoped=true"
import script from "./ValueModules.vue?vue&type=script&lang=js"
export * from "./ValueModules.vue?vue&type=script&lang=js"
import style0 from "./ValueModules.vue?vue&type=style&index=0&id=1b44148f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b44148f",
  null
  
)

export default component.exports